import { Fragment } from "react";
import PageShell from "@/components/PageShell";

export const Review = () => (
  <span
    data-testid="legal-review-badge"
    className="mx-0.5 inline-block rounded border border-amber-300 bg-amber-100 px-1.5 py-0.5 align-middle text-[10px] font-bold uppercase tracking-wider text-amber-700"
  >
    Review
  </span>
);

const RichText = ({ text }) => {
  const parts = text.split("[REVIEW]");
  return (
    <>
      {parts.map((part, i) => (
        <Fragment key={i}>
          {part}
          {i < parts.length - 1 && <Review />}
        </Fragment>
      ))}
    </>
  );
};

const CONTACT = {
  company: "Mountain Fresh Farms LLP",
  address: "Rajaram Industrial Estate, Vellandipalayam, Coimbatore – 641025, Tamil Nadu, India",
  email: "info@zentrafoods.in",
  phone: "+91 90031 40803",
};

const LegalDoc = ({ title, updated, intro = "", sections, testId }) => {
  const hasReview =
    intro.includes("[REVIEW]") ||
    sections.some(
      (s) =>
        (s.heading && s.heading.includes("[REVIEW]")) ||
        s.paragraphs?.some((p) => p.includes("[REVIEW]")) ||
        s.list?.some((li) => li.includes("[REVIEW]"))
    );

  return (
    <PageShell>
      <div className="bg-white text-neutral-800" data-testid={testId}>
        <div className="mx-auto max-w-3xl px-6 py-16 lg:py-24">
          <p className="text-[11px] font-semibold uppercase tracking-[0.25em] text-neutral-400">
            ZENTRA · Legal
          </p>
          <h1 className="mt-3 text-3xl font-bold tracking-tight text-neutral-900 sm:text-4xl">
            {title}
          </h1>
          <p className="mt-2 text-sm text-neutral-500">Last updated: {updated}</p>

          {hasReview && (
            <div className="mt-8 rounded-lg border border-amber-200 bg-amber-50 p-4 text-sm leading-relaxed text-amber-800">
              <span className="font-semibold">Draft note:</span> parts of this page marked{" "}
              <Review /> are placeholders that should be confirmed by Mountain Fresh Farms LLP
              before this policy is treated as final.
            </div>
          )}

          <p className="mt-8 text-base leading-relaxed text-neutral-700">
            <RichText text={intro} />
          </p>

          {sections.map((section, idx) => (
            <section key={idx} className="mt-10">
              <h2 className="text-lg font-semibold text-neutral-900">
                <RichText text={section.heading} />
              </h2>
              {section.paragraphs?.map((p, i) => (
                <p key={i} className="mt-3 text-base leading-relaxed text-neutral-700">
                  <RichText text={p} />
                </p>
              ))}
              {section.list && (
                <ul className="mt-3 list-disc space-y-2 pl-6 text-base leading-relaxed text-neutral-700">
                  {section.list.map((li, i) => (
                    <li key={i}>
                      <RichText text={li} />
                    </li>
                  ))}
                </ul>
              )}
            </section>
          ))}

          <section className="mt-12 rounded-xl border border-neutral-200 bg-neutral-50 p-6">
            <h2 className="text-lg font-semibold text-neutral-900">Contact Us</h2>
            <p className="mt-3 text-base leading-relaxed text-neutral-700">
              {CONTACT.company} (brand: ZENTRA)
              <br />
              {CONTACT.address}
              <br />
              Email:{" "}
              <a
                href={`mailto:${CONTACT.email}`}
                data-testid={`${testId}-email-link`}
                className="font-medium text-[#4d8a12] underline underline-offset-2"
              >
                {CONTACT.email}
              </a>
              <br />
              Phone / WhatsApp:{" "}
              <a
                href="tel:+919003140803"
                data-testid={`${testId}-phone-link`}
                className="font-medium text-[#4d8a12] underline underline-offset-2"
              >
                {CONTACT.phone}
              </a>
            </p>
          </section>
        </div>
      </div>
    </PageShell>
  );
};

export default LegalDoc;
